import React from "react";

import RegisterLayout from "@/features/auth/components/registerLayout/RegisterLayout";

function Register() {
	return <RegisterLayout />;
}

export default Register;
